export const AUTH_LOGIN_START =  'AUTH_LOGIN_START';
export const AUTH_LOGIN =  'AUTH_LOGIN';
export const AUTH_LOGIN_END =  'AUTH_LOGIN_END';
export const AUTH_LOGIN_ERROR =  'AUTH_LOGIN_ERROR';

export const AUTH_LOGOUT_START =  'AUTH_LOGOUT_START';
export const AUTH_LOGOUT =  'AUTH_LOGOUT';
export const AUTH_LOGOUT_END =  'AUTH_LOGOUT_END';
